function initBundleDeal( )
{
    document.addEventListener( "click", handleBundleaATCClick );
    document.addEventListener( "click", handleBundleClick );
}

function handleBundleaATCClick( e )
{
    if ( e.target.matches( ".bundle-deal-atc" ) )
    {
        gtag( 'event', 'multibuy_add_to_cart' );

        var input = document.querySelector( ".bundle-label .bundle-input:checked" );
        if ( input )
        {
            //Some ATC code taken from theme.js line: 2386 onwards handleFormSubmission method

            var itemQuantity     = input.getAttribute( "value" );
            var variantId        = JSON.parse( document.querySelector( "[data-selected-variant]" ).innerHTML ).id;
            var productId        = document.querySelector( "product-info" ).dataset.productId;
            var sectionId        = e.target.dataset.sectionId;
            var form             = input.closest( ".product__info-container" ).querySelector( ".product-form form" );
            let sectionsToBundle = [];
            document.documentElement.dispatchEvent( new CustomEvent( 'cart:grouped-sections',
                {
                    bubbles: true,
                    detail:
                    {
                        sections: sectionsToBundle
                    }
                }
            ));

            if ( variantId && productId && sectionId && form && itemQuantity )
            {
                var addableAmount = form.getActualAddableAmount( variantId, itemQuantity );

                let formData =
                {
                    "id"          : variantId,
                    "quantity"    : addableAmount,
                    "product-id"  : productId,
                    "section-id"  : sectionId,
                    "sections"    : sectionsToBundle,
                    "sections_url": window.location.pathname
                };
                
                fetch( window.Shopify.routes.root + 'cart/add.js',
                {
                    method: 'POST',
                    headers:
                    {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify( formData )
                })
                .then( response => response.json( ) )
                .then( async response =>
                {
                    if ( response.status )
                    {
                        form.handleCartError( response );
                    }
                    else if ( addableAmount < itemQuantity && form.variantLimitError != "" )
                    {
                        form.displayFormErrors( form.variantLimitError );
                    }

                    const cartJson = await ( await fetch( `${ FoxTheme.routes.cart_url }`, { ...FoxTheme.utils.fetchConfig( ) } ) ).json( );
                    cartJson[ 'sections' ] = response[ 'sections' ];
                    form.updateCartState(cartJson);
                    form.dispatchProductAddedEvent(response);
                    form.showCartDrawer();
                })
                .catch( ( error ) =>
                {
                    console.error( 'Error:', error );
                });
            }
            else
            {
                console.log( `Missing data:\nVariantID: ${variantId}\nProductID: ${productId}\nSectionID: ${sectionId}\nForm${form}\nQuantity: ${itemQuantity}` );
            }            
        }
    }
}

function handleBundleClick( e )
{
    //can't directly target label as inner element clicks won't be registered
    if ( e.target.closest( ".quick-add__content .bundle-label" ) && window.innerWidth < 769 )  
    {
        var atc = document.querySelector( ".quick-add__content .bundle-deal-atc" );
        atc.scrollIntoView( { behavior: "smooth", block: "center", inline: "center" } );
    }
}

initBundleDeal( );